import { useCallback, useState } from "react";
import { getLocalStorageJson, setLocalStorageJson } from "../utils/localStorageUtil";

const usePersistedState = ({ key, defaultValue }) => {
   const [value, setStateValue] = useState(() => {
      const stored = getLocalStorageJson(key);
      return stored === null ? defaultValue : stored;
   });

   const setValue = useCallback((next) => {
      setStateValue((prev) => {
         const resolved = typeof next === "function" ? next(prev) : next;
         setLocalStorageJson(key, resolved);
         return resolved;
      });
   }, [key]);

   return [value, setValue];
};

export default usePersistedState;
